import React from "react";

const GrantorLicenseUploadField = ({
  label,
  inputId,
  fileRef,
  onTriggerClick,
  onFileChange,
  onRemove,
  fileName,
  previewUrl,
  isUploading,
  isUploaded,
  error,
  showError,
}) => {
  return (
    <div className="col-md-12">
      <div className="main_form_box d-flex align-items-center mt-2">
        <svg
          width="20"
          height="24"
          viewBox="0 0 20 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 0H3C2.45 0 2 0.45 2 1C2 1.55 2.45 2 3 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0ZM3 24H17C17.55 24 18 23.55 18 23C18 22.45 17.55 22 17 22H3C2.45 22 2 22.45 2 23C2 23.55 2.45 24 3 24ZM18 4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4ZM10 6.75C11.24 6.75 12.25 7.76 12.25 9C12.25 10.24 11.24 11.25 10 11.25C8.76 11.25 7.75 10.24 7.75 9C7.75 7.76 8.76 6.75 10 6.75ZM15 17H5V15.5C5 13.83 8.33 13 10 13C11.67 13 15 13.83 15 15.5V17Z"
            fill="#42474E"
          />
        </svg>

        <div className="form-group d-flex justify-content-between w-100">
          <label htmlFor={inputId} className="cursor-pointer w-100">
            {label}
          </label>
          <div style={{ position: "relative" }}>
            <svg
              width="26"
              height="32"
              viewBox="0 0 26 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ cursor: "pointer" }}
              onClick={onTriggerClick}
            >
              <path
                d="M16.1666 0.166504H3.49992C1.75825 0.166504 0.349086 1.5915 0.349086 3.33317L0.333252 28.6665C0.333252 30.4082 1.74242 31.8332 3.48408 31.8332H22.4999C24.2416 31.8332 25.6666 30.4082 25.6666 28.6665V9.6665L16.1666 0.166504ZM22.4999 28.6665H3.49992V3.33317H14.5833V11.2498H22.4999V28.6665ZM6.66658 20.7657L8.89909 22.9982L11.4166 20.4965V27.0832H14.5833V20.4965L17.1008 23.014L19.3333 20.7657L13.0158 14.4165L6.66658 20.7657Z"
                fill="#42474E"
              />
            </svg>
            <input
              type="file"
              id={inputId}
              name={inputId}
              onChange={onFileChange}
              style={{ display: "none" }}
              ref={fileRef}
            />
          </div>
        </div>
      </div>

      {fileName ? (
        <div className="selected-file-info mt-2 d-flex align-items-center gap-2">
          {previewUrl ? (
            <img
              src={previewUrl}
              alt={`${label} preview`}
              className="selected-file-preview"
            />
          ) : (
            <span className="selected-file-icon">📄</span>
          )}
          <div className="flex-grow-1">
            <div className="selected-file-name">{fileName}</div>
            <div className="selected-file-status">
              {isUploading
                ? "Uploading..."
                : isUploaded
                  ? "Uploaded successfully"
                  : ""}
            </div>
          </div>
          <button
            type="button"
            className="selected-file-remove"
            onClick={onRemove}
            aria-label={`Remove ${label}`}
          >
            Remove
          </button>
        </div>
      ) : null}

      {showError && error ? <div className="error">{error}</div> : null}
    </div>
  );
};

export default GrantorLicenseUploadField;
